export const ROLES = {
  ADMIN: 'ADMIN',
  CONTRIB: 'CONTRIB',
  VIEWER: 'VIEWER'
};
const rolesId = {
  ADMIN: 3,
  CONTRIB: 2,
  VIEWER: 1
};
export const DIVISIONS = {
  FBP: 'FBP',
  FSH: 'FSH',
  WFJ: 'WFJ',
  '3DIV': '3DIV',
  TROIS_DIV: '3DIV',
  ALL: '*'
};

export function isAllowed(
  user,
  minimumRole,
  authorizedDivisions = [DIVISIONS.ALL]
) {
  if (user && user.role && user.division) {
    const divisionOk = authorizedDivisions.reduce((status, division) => {
      if (isUserDivisionAcceptable(user.division, division)) {
        status = true;
      }
      return status;
    }, false);

    if (rolesId[user.role] >= rolesId[minimumRole] && divisionOk) {
      return true;
    }
  }
  return false;
}

function isUserDivisionAcceptable(userDivision, wantedDivision) {
  // All division allowed so its true (whatever the user is)
  if (wantedDivision === DIVISIONS.ALL) {
    return true;
  }
  // if user is 3DIV he has access to everything
  if (
    userDivision === DIVISIONS['3DIV'] ||
    userDivision === DIVISIONS.TROIS_DIV
  ) {
    return true;
  }
  if (userDivision === wantedDivision) {
    return true;
  }
  return false;
}
